import { TileRoleRoute } from '@/types'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { Roles } from '@/auth/azure/Roles'
import React from 'react'
import { faListSquares } from '@fortawesome/free-solid-svg-icons'

export const RepartoRoute: TileRoleRoute = {
  path: 'reparto',
  text: 'Reparto',
  faIcon: faListSquares,
  element: (
    <ManagementGridFactory
      entity="reparto"
      referencesCollection={'impiegati'}
      referencesTitle="Impiegati"
      entityRoute={'admin/users'}
      displayField="id"
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Reparto',
      icon: faListSquares,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
}
